// @flow

import _ from 'lodash';
import window from 'window';
import onBeforeUnloadHandler from 'window-onbeforeunload-handler';
import type { Observable } from 'rgs-knockout';
import ko from 'rgs-knockout';

import TinyRouter from 'tiny-hash-router';

import type { RouteFilter } from './route';
import { Route } from './route';
import type {
	ITinyHashRouter,
	RouteHandlerResult,
	RouteParts,
} from 'app/rgs/routing/contracts';

export type QueryParamObject = {
	[string]: string | number;
}

// TODO: REMAKE OR CREATE MORE BETTER THAN THIS

export class Router<TRouteParts, TQueryParams, TBeforeQueryParams> {
	handlerResult: Observable<RouteHandlerResult> = ko.observable();
	_router: ITinyHashRouter;
	_routeParts: RouteHandlerResult;
	_routeName: string;
	_subscribers: Map<string, Function[]>;
	_callbacksOnRouteChange: Array<Function> = [];

	constructor (router: ?ITinyHashRouter) {
		this._router = router || new TinyRouter();
		this._subscribers = new Map();
		this._router.registerListener();

		window.addEventListener('hashchange', this._notifySubscribers);

		onBeforeUnloadHandler.push(() => {
			window.removeEventListener('hashchange', this._notifySubscribers);
			return false;
		});
	}

	get queryParams (): TQueryParams {
		return this.handlerResult().routeParts.queryParams;
	}

	get beforeQueryParams (): TBeforeQueryParams {
		return this.handlerResult().routeParts.beforeQueryParams;
	}

	get routeParts (): TRouteParts {
		return this.handlerResult().routeParts.parts;
	}

	get routeName (): string {
		return this.handlerResult().routeName;
	}

	get groupRouteName (): string {
		return this.handlerResult().groupRouteName;
	}

	registerRoute (route: Route): void {
		const { urlPattern, callback } = route;
		this._router
			.route(urlPattern, callback)
			.name(route.name);

		if (route.filters) {
			this._registerFilters(route.filters);
		}
	}

	/**
	 * @deprecated
	 * Returns url hash for the given route and route parts.
	 * @param {string} routeName - Route name.
	 * @param {string[]} parts - Url parts values
	 * @return {string} - Url hash
	 */
	url (routeName: string, ...parts: string[]): string {
		return this._router.url(routeName, ...parts);
	}

	run (): void {
		this._router.run();
	}

	// TODO: перенести _prepareParts в tiny-hash-router
	// _prepareParts = (
	// 	routeName: $PropertyType<RouteHandlerResult, 'routeName'>,
	// 	parts: $PropertyType<RouteParts, 'parts'> = {},
	// ): string[] => {
	// 	const prepareParts = [];
	//
	// 	if (_.isNil(parts)) {
	// 		return prepareParts;
	// 	}
	//
	// 	if (!this._router.routesByName.hasOwnProperty(routeName)) {
	// 		return prepareParts;
	// 	}
	//
	// 	const route: ITinyHashRoute = this._router.routesByName[routeName];
	// 	const varPos = route.varPos;
	//
	// 	const calcVarPos = (key: string): number => varPos.findIndex((currentValue) => currentValue === key);
	//
	// 	console.log('route:', route, 'parts:', parts);
	//
	// 	let pos = -1;
	// 	for (let key: string in parts) {
	// 		if (parts.hasOwnProperty(key)) {
	// 			pos = calcVarPos(key);
	//
	// 			if (pos >= 0) {
	// 				prepareParts[pos] = parts[key];
	// 			}
	// 		}
	// 	}
	//
	// 	return prepareParts;
	// };

	genHashUrl = (
		routeName: string,
		parts?: $PropertyType<RouteParts, 'parts'>,
		queryParams?: $PropertyType<RouteParts, 'queryParams'>,
		beforeQueryParams?: $PropertyType<RouteParts, 'beforeQueryParams'>,
	): string => {
		// return this._router.url(routeName, ...parts);
		let resUrl = '';

		const tempArr: string[] = [];
		if (!_.isNil(beforeQueryParams)) {
			for (let key: string in beforeQueryParams) {
				tempArr.push(`${key}=${beforeQueryParams[key]}`);
			}
			if (tempArr.length > 0) {
				resUrl += '?' + _.join(tempArr, '&');
			}
		}

		// const prepareParts = this._prepareParts(routeName, parts);

		if (_.isEmpty(queryParams)) {
			queryParams = undefined;
		}

		resUrl += '#';
		resUrl += this._router.url(routeName, parts, queryParams);
		return resUrl;
	};

	setUrl (
		routeName: string,
		parts?: $PropertyType<RouteParts, 'parts'>,
		queryParams?: $PropertyType<RouteParts, 'queryParams'>,
		beforeQueryParams?: $PropertyType<RouteParts, 'beforeQueryParams'>,
	): void {
		window.location.hash = this.genHashUrl(routeName, parts, queryParams, beforeQueryParams);
	}

	/**
	 * @deprecated
	 * fwfwfdwf
	 * @param {string} routeName - routeName
	 * @param {string[]} routeParts - routeParts
	 * @param {QueryParamObject} queryParams - queryParams
	 * @return {undefined} - undefined
	 */
	setUrlWithQueryParams (routeName: string, routeParts: string[], queryParams: QueryParamObject) {
		const urlHash = this._router.urlWithQueryParams(routeName, routeParts, queryParams);

		window.location.hash = `#${urlHash}`;
	}

	setRouteParts (routeName: string, handlerResult: RouteHandlerResult): void {
		// TODO: избавиться от _routeParts и отдельного _routeName
		this._routeName = routeName;
		this.handlerResult(handlerResult);
		this._routeParts = handlerResult;
	}

	onRouteChange (callback: Function) {
		this._callbacksOnRouteChange.push(callback);
	}

	_registerFilters (filters: Array<RouteFilter>): void {
		if (!filters) {
			return;
		}

		filters.forEach(filter => {
			this._router
				.addFilter(filter.partName, filter.predicate);
		});
	}

	_notifySubscribers = (...args: Array<any>) => {
		this._callbacksOnRouteChange.forEach(callback => callback(...args));

		[...this._subscribers.values()].forEach(callbacks =>
			callbacks.forEach((item: Function) => item(this.routeParts)),
		);
	};

	subscribe (key: string, value: Function) {
		const prev = this._subscribers.get(key) || [];

		this._subscribers.set(key, prev.concat(value));
	}

	dispose (key: string) {
		if (key) {
			this._subscribers.delete(key);
		}
	}
}
